import { SdkCustomerReportClient } from "./SdkCustomerReportClient";

export class SdkTenantReportClient extends SdkCustomerReportClient {    

}